const { getElement, getElements, getOffsetTop } = window.BAO.Utils

// eslint-disable-next-line no-undef
class LoadMoreList extends window.BAO.CustomElement() {
  constructor () {
    super()

    const url = window.location.href
    this.urlSplit = url.split('#')
    this.elementId = this.urlSplit[1]

    this.currentPage = this.options.currentPage

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollPos = document.body.getBoundingClientRect().top

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.mouseoverLink = this.mouseoverLink.bind(this)
    this.mouseoutLink = this.mouseoutLink.bind(this)
    this.clickLink = this.clickLink.bind(this)
    this.mousedownLink = this.mousedownLink.bind(this)
    this.mouseupLink = this.mouseupLink.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)

    // Last clicked item data
    this.lastClickedItemHrefKey = 'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.trigger && this.els.trigger.exists) {
      this.listeners.add(
        this.els.trigger.element,
        'click',
        this.handleClick.bind(this),
      )
    }

    if (this.els.previous && this.els.previous.exists) {
      this.listeners.add(
        this.els.previous.element,
        'click',
        this.handleClickPrevious.bind(this),
      )
    }

    if (this.dataset.infiniteScroll === 'true') {
      this.onScroll = this.onScroll.bind(this)
      window.addEventListener('scroll', this.onScroll, { passive: true })
    }

    if (this.currentPage !== 1) {
      window.addEventListener('load', this.showPreviousButton.bind(this))
    }

    if (
      this.currentPage === this.options.totalPages ||
      this.dataset.infiniteScroll === 'true'
    ) {
      window.addEventListener('load', this.hideLoadMore.bind(this))
    }

    this.els.item.elements.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseover', this.mouseoverLink)
      this.listeners.add(itemEl, 'mouseout', this.mouseoutLink)
      this.listeners.add(itemEl, 'click', this.clickLink)
      this.listeners.add(itemEl, 'mousedown', this.mousedownLink)
      this.listeners.add(itemEl, 'mouseup', this.mouseupLink)
      this.listeners.add(document.documentElement, 'keydown', this.onKeyPress)
    })
  }

  handleClick () {
    this.loadMore()
  }

  handleClickPrevious () {
    this.loadPrevious()
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.setScrollDirection()

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.checkTriggerStatus()
  }

  setScrollDirection () {
    if (document.body.getBoundingClientRect().top > this.scrollPos) {
      this.scrollDirection = 'up'
    } else {
      this.scrollDirection = 'down'
    }

    this.scrollPos = document.body.getBoundingClientRect().top
  }

  showPreviousButton () {
    this.els.previous.element.setAttribute('aria-hidden', false)
  }

  hidePreviousButton () {
    this.els.previous.element.setAttribute('aria-hidden', true)
  }

  hideLoadMore () {
    this.els?.trigger?.element?.setAttribute('aria-hidden', true)
  }

  setInsetCards () {
    document.querySelectorAll('.prd-List_Item').forEach(el => {
      el.classList.remove('prd-List_Item-inset')

      if (el.offsetLeft === 0) el.classList.add('prd-List_Item-inset')
    })
  }

  async loadMore () {
    this.loading = true

    this.currentPage += 1

    // eslint-disable-next-line compat/compat
    const queries = new URLSearchParams(window.location.search)
    queries.set('page', (this.lastItemPage + 1).toString())

    window.history.pushState({}, '', `?${queries.toString()}`)

    if (this.options.sectionId && this.options.sectionId.length) {
      queries.set('sections', this.options.sectionId)
    }

    const sectionHTML = await this.fetchSection(queries.toString())
    const newSectionDOM = new DOMParser().parseFromString(
      sectionHTML,
      'text/html',
    )

    this.dataset.currentPage = this.currentPage

    const firstProductCardId = getElements(this.options.itemSelector, {
      context: newSectionDOM,
    })[0].dataset.id

    this.appendNewItemsToTarget(newSectionDOM)

    // Focus element
    getElement(`[data-id="${firstProductCardId}"] .prd-Card_FauxLink`, {
      context: this.els.target.element,
    }).focus()

    document
      .querySelectorAll('[data-load-more-list-el="item"] img[srcset]')
      .forEach(image => {
        // eslint-disable-next-line no-self-assign
        image.outerHTML = image.outerHTML
      })

    this.setInsetCards()

    if (this?.els?.trigger?.exists) {
      const totalPages = this.options.totalPages
      const secondLastPage = totalPages - 1
      const currentPage = this.options.currentPage
      const paginationAmount = this.options.perPage
      const totalProducts = this.options.totalItems

      let productsToLoad

      if (currentPage === secondLastPage) {
        const numberOfPagesLoaded = secondLastPage
        const numberOfProductsLoaded = numberOfPagesLoaded * paginationAmount
        productsToLoad = totalProducts - numberOfProductsLoaded
      } else {
        productsToLoad = paginationAmount
      }

      this.els.trigger.element.textContent = `Load ${productsToLoad} more products`
    }

    this.loading = false

    this.dispatchEvent(
      new CustomEvent(window.BAO.EVENTS.LOAD_MORE.FETCHED_NEXT_PAGE, {
        detail: {
          currentPage: this.options.currentPage,
          totalPages: this.options.totalPages,
        },
        bubbles: true,
      }),
    )
  }

  async loadPrevious () {
    this.loading = true

    this.currentPage -= 1

    // eslint-disable-next-line compat/compat
    const queries = new URLSearchParams(window.location.search)
    queries.set('page', (this.firstItemPage - 1).toString())

    window.history.pushState({}, '', `?${queries.toString()}`)

    if (this.options.sectionId && this.options.sectionId.length) {
      queries.set('sections', this.options.sectionId)
    }

    const sectionHTML = await this.fetchSection(queries.toString())
    const newSectionDOM = new DOMParser().parseFromString(
      sectionHTML,
      'text/html',
    )

    this.dataset.currentPage = this.currentPage

    if (this.firstItemPage - 1 === 1) {
      this.hidePreviousButton()
    }

    this.prependNewItemsToTarget(newSectionDOM)

    document
      .querySelectorAll('[data-load-more-list-el="item"] img[srcset]')
      .forEach(image => {
        // eslint-disable-next-line no-self-assign
        image.outerHTML = image.outerHTML
      })

    this.setInsetCards()

    this.loading = false

    this.dispatchEvent(
      new CustomEvent(window.BAO.EVENTS.LOAD_MORE.FETCHED_PREV_PAGE, {
        detail: {
          currentPage: this.options.currentPage,
          totalPages: this.options.totalPages,
        },
        bubbles: true,
      }),
    )
  }

  checkTriggerStatus () {
    if (
      this.loading === true ||
      !this.els.loadmore_pagination?.exists ||
      this.currentItemCount >= this.options.totalItems
    ) {
      return
    }

    const loadMoreTriggerPoint =
      getOffsetTop(this.els.loadmore_pagination.element) -
      window.innerHeight * 3

    // Do not load more if we've loaded all products, or are on the last page.
    if (
      this.lastKnownY >= loadMoreTriggerPoint &&
      this.currentPage < this.options.totalPages &&
      this.lastItemPage < this.options.totalPages &&
      this.scrollDirection === 'down'
    ) {
      this.loadMore()
    }
  }

  fetchSection (queryString) {
    if (this.options.sectionId && this.options.sectionId.length) {
      return fetch(`${this.options.url}/?${queryString}`)
        .then(response => response.json())
        .then(response => response[this.options.sectionId])
    } else {
      return fetch(`${this.options.url}/?${queryString}`)
        .then(response => response.text())
        .then(response => {
          return response
        })
    }
  }

  appendNewItemsToTarget (DOM) {
    const fragment = document.createDocumentFragment()
    const newItems = getElements(this.options.itemSelector, { context: DOM })
    newItems.forEach(item => fragment.appendChild(item))

    this.els.target.element.appendChild(fragment)

    if (this.currentItemCount >= this.options.totalItems) {
      this.els.trigger.element.remove()

      window.removeEventListener('scroll', this.onScroll, { passive: true })
    }

    newItems.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseover', this.mouseoverLink)
      this.listeners.add(itemEl, 'mouseout', this.mouseoutLink)
      this.listeners.add(itemEl, 'click', this.clickLink)
      this.listeners.add(itemEl, 'mousedown', this.mousedownLink)
      this.listeners.add(itemEl, 'mouseup', this.mouseupLink)
      this.listeners.add(document.documentElement, 'keydown', this.onKeyPress)
    })
  }

  prependNewItemsToTarget (DOM) {
    const fragment = document.createDocumentFragment()
    const newItems = getElements(this.options.itemSelector, { context: DOM })
    newItems.forEach(item => fragment.append(item))

    this.els.target.element.prepend(fragment)

    if (this.currentItemCount >= this.options.totalItems) {
      this.els.trigger.element.remove()

      window.removeEventListener('scroll', this.onScroll, { passive: true })
    }

    newItems.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseover', this.mouseoverLink)
      this.listeners.add(itemEl, 'mouseout', this.mouseoutLink)
      this.listeners.add(itemEl, 'click', this.clickLink)
      this.listeners.add(itemEl, 'mousedown', this.mousedownLink)
      this.listeners.add(itemEl, 'mouseup', this.mouseupLink)
      this.listeners.add(document.documentElement, 'keydown', this.onKeyPress)
    })
  }

  mouseoverLink (e) {
    const card = e.target.closest('[data-product-card-el="card"]')
    if (card?.dataset?.available === 'false') {
      const priceEl = card
        .querySelector('.prd-Card_Content')
        ?.querySelector('[data-product-card-el="price"]')

      if (!priceEl) return

      priceEl.textContent = window.theme.strings.notifyMe
    }

    const isBis = e.target.closest('[data-bis]')
    const priceEl = e.target
      .closest('.prd-Card_Content')
      ?.querySelector('[data-product-card-el="price"]')

    if (!priceEl || !isBis) return

    priceEl.textContent = window.theme.strings.notifyMe
  }

  mouseoutLink (e) {
    const card = e.target.closest('[data-product-card-el="card"]')
    if (card?.dataset?.available === 'false') {
      const priceEl = card
        .querySelector('.prd-Card_Content')
        ?.querySelector('[data-product-card-el="price"]')

      if (!priceEl) return

      priceEl.textContent = priceEl.dataset.price
    }

    const isBis = e.target.closest('[data-bis]')
    const priceEl = e.target
      .closest('.prd-Card_Content')
      ?.querySelector('[data-product-card-el="price"]')

    if (!priceEl || !isBis) return

    priceEl.textContent = priceEl.dataset.price
  }

  /** @param {Event} e */
  clickLink (e) {
    const isProductDetails = e.target.closest('.prd-Card_Details')
    const isQuickBuy = e.target.closest('[data-quickbuy]')
    const isBis = e.target.closest('[data-bis]')
    const isPromoCard = e.target
      .closest('[data-load-more-list-el="item"]')
      .hasAttribute('data-promocard')
    const isWishlist = e.target.closest('.iWishAddColl')

    if (
      isProductDetails ||
      isQuickBuy ||
      isPromoCard ||
      isWishlist ||
      isBis ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return
    }

    e.preventDefault()
    e.stopPropagation()
  }

  /** @param {Event} e */
  mousedownLink (e) {
    if (
      e.target
        .closest('[data-load-more-list-el="item"]')
        .hasAttribute('data-promocard')
    ) {
      return
    }
    this.startX = e.pageX
    this.startY = e.pageY
  }

  /** @param {Event} e */
  mouseupLink (e) {
    const isQuickBuy = e.target.closest('[data-quickbuy]')
    const isPromoCard = e.target
      .closest('[data-load-more-list-el="item"]')
      .hasAttribute('data-promocard')

    const isWishlist = e.target.closest('.iWishAddColl')
    const isBis = e.target.closest('[data-bis]')

    if (
      isQuickBuy ||
      isPromoCard ||
      isWishlist ||
      isBis ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return
    }

    if (e.target.tagName === 'BUTTON') {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const delta = 6
    const diffX = Math.abs(e.pageX - this.startX)
    const diffY = Math.abs(e.pageY - this.startY)
    if (diffX < delta && diffY < delta) {
      const listItem = e.target.closest('.prd-List_Item')
      const id = listItem.dataset.id
      const page = listItem.dataset.page

      // eslint-disable-next-line compat/compat
      const url = new URL(window.location)
      url.searchParams.set('page', page)
      url.searchParams.set('view', 'default')
      url.hash = id

      window.history.pushState({}, '', `${url.search}${url.hash}`)

      const getLink = listItem.querySelector('a[data-product-card-el="link"]')

      window.location = getLink.getAttribute('href')

      // Set storage data for collection-scroll-position.js
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        getLink.getAttribute('href')?.toString(),
      )
    }
  }

  onKeyPress (e) {
    if (e.key !== 'Enter') return

    const isItemChild = e.target.closest('[data-load-more-list-el="item"]')
    if (!isItemChild) return

    const isQuickBuy = e.target.closest('[data-quickbuy]')
    const isPromoCard = e.target
      .closest('[data-load-more-list-el="item"]')
      ?.hasAttribute('data-promocard')
    const isWishlist = e.target.closest('.iWishAddColl')
    const isBis = e.target.closest('[data-bis]')

    if (isQuickBuy || isPromoCard || isWishlist || isBis) {
      return
    }

    if (e.target.tagName === 'BUTTON') {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const listItem = e.target.closest('.prd-List_Item')
    const id = listItem.dataset.id
    const page = listItem.dataset.page

    // eslint-disable-next-line compat/compat
    const url = new URL(window.location)
    url.searchParams.set('page', page)
    url.searchParams.set('view', 'default')
    url.hash = id

    window.history.pushState({}, '', `${url.search}${url.hash}`)

    const getLink = listItem.querySelector('a[data-product-card-el="link"]')
    window.location = getLink.getAttribute('href')
  }

  /** @param {HTMLElement} el */
  scrollToElement (el) {
    if (!el) {
      return
    }

    /**
     * @note For some reason el.scrollIntoView() wasn't working here,
     * so we're having to calculate the top of the element and scroll the
     * window to that position manually
     */

    const boundingRect = el.getBoundingClientRect()
    const distanceFromTopOfPage = Math.round(
      window.pageYOffset + boundingRect.top,
    )

    window.scrollTo({
      top: distanceFromTopOfPage,
      behavior: 'instant',
    })
  }

  get firstItemPage () {
    const firstItem = this.currentItems[0]

    return Number(firstItem.dataset.page)
  }

  get lastItemPage () {
    const lastItem = this.currentItems[this.currentItemCount - 1]

    return Number(lastItem.dataset.page)
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    this.setAttribute('aria-busy', val.toString())
  }

  get currentItems () {
    return getElements(this.options.itemSelector, {
      context: this,
    })
  }

  get currentItemCount () {
    return this.currentItems.length
  }

  get options () {
    return {
      itemSelector: this.dataset.itemSelector
        ? this.dataset.itemSelector
        : `[data-load-more-list-el="item"]`,
      perPage: parseInt(
        this.dataset.itemsPerPage ? this.dataset.itemsPerPage : 10,
        10,
      ),
      columnCount: this.dataset.columnCount
        ? parseInt(this.dataset.columnCount, 10)
        : 1,
      currentPage: parseInt(
        this.dataset.currentPage ? this.dataset.currentPage : 1,
        10,
      ),
      totalPages: parseInt(
        this.dataset.totalPages ? this.dataset.totalPages : 1,
        10,
      ),
      totalItems: parseInt(
        this.dataset.totalItems ? this.dataset.totalItems : 1,
        10,
      ),
      sectionId: this.dataset.sectionId ? this.dataset.sectionId : '',
      url: this.dataset.url ? this.dataset.url : '',
    }
  }
}

if (!customElements.get('load-more-list')) {
  customElements.define('load-more-list', LoadMoreList)
}
